import { render, staticRenderFns } from "./LavorazioneCarroConvoglio.vue?vue&type=template&id=30b498fa&scoped=true&"
import script from "./LavorazioneCarroConvoglio.vue?vue&type=script&lang=js&"
export * from "./LavorazioneCarroConvoglio.vue?vue&type=script&lang=js&"
import style0 from "./LavorazioneCarroConvoglio.vue?vue&type=style&index=0&id=30b498fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b498fa",
  null
  
)

export default component.exports